
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rezervace",
      function () {
        return require("private-next-pages/rezervace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rezervace"])
      });
    }
  